import '@babel/polyfill'
import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import Vuelidate from 'vuelidate'
import Raven from 'raven-js'
import RavenVue from 'raven-js/plugins/vue'
import VueLazyload from 'vue-lazyload'
import VueObserveVisibility from 'vue-observe-visibility'
import VirtualCollection from 'vue-virtual-collection'

Vue.config.productionTip = false

import routes from './routes'

import './styles/quasar.styl'
import lang from 'quasar-framework/i18n/pl'
import 'quasar-extras/animate'
import 'quasar-extras/roboto-font'
import 'quasar-extras/material-icons'
import 'quasar-extras/fontawesome'
import {
    Quasar,
    QBtn,
    QLayout,
    QLayoutHeader,
    QLayoutFooter,
    QLayoutDrawer,
    QPage,
    QPageContainer,
    QToolbar,
    QToolbarTitle,
    QList,
    QListHeader,
    QItemSeparator,
    QItem,
    QItemSide,
    QItemMain,
    QField,
    QInput,
    QCard,
    QCardActions,
    QCardSeparator,
    QAlert,
    QTable,
    QTh,
    QTr,
    QTd,
    QTableColumns,
    QModal,
    QChatMessage,
    QUploader,
    Dialog,
    Notify,

} from 'quasar'

Vue.use(Quasar, {
    config: {
        animations: 'all',
    },
    components: {
        QBtn,
        QLayout,
        QLayoutHeader,
        QLayoutFooter,
        QLayoutDrawer,
        QPage,
        QPageContainer,
        QToolbar,
        QToolbarTitle,
        QList,
        QListHeader,
        QItemSeparator,
        QItem,
        QItemSide,
        QItemMain,
        QField,
        QInput,
        QCard,
        QSelect,
        QCardActions,
        QCardSeparator,
        QCardMain,
        QCardTitle,
        QAlert,
        QTable,
        QTh,
        QTr,
        QTd,
        QTableColumns,
        QModal,
        QChatMessage,
        QUploader,
    },
    directives: {},
    plugins: {
        Dialog,
        Notify,
    },
    i18n: lang,
})

const router = new VueRouter({
    routes,
})

Vue.use(VueRouter)
Vue.use(Vuelidate)
Vue.use(VirtualCollection)

Vue.use(VueLazyload, {
    preLoad: 1,
    attempt: 1,
    lazyComponent: true,
    throttleWait: 500,
    observer: true,
})

Vue.use(VueObserveVisibility)

import store from './store'
import { QCardMain, QCardTitle, QSelect } from 'quasar-framework'

function appInit () {
    new Vue({
        render: h => h(App),
        router,
        store,
    }).$mount('#app')
}

if (process.env.VUE_APP_SENTRY_DSN) {
    Raven.config(process.env.VUE_APP_SENTRY_DSN, {
        release: process.env.VUE_APP_RELEASE,
    }).
        addPlugin(RavenVue, Vue).
        install()
    Raven.context(appInit)
} else {
    appInit()
}